import { Check } from "akar-icons";
import React from "react";

export const SuccessCheckIcon = () => {
  return (
    <Check
      size={15}
      style={{
        stroke: "#fff",
        strokeWidth: "3px",
        backgroundColor: "#D1E7C3",
        borderRadius: "50%",
        padding: "2px",
      }}
    />
  );
};
